import React from 'react';
import Hero from '../Components/Hero';
import '../styles/main.scss';

import { block1Data } from '../data.js';
import { block2Data } from '../data.js';
import BlockLeft from '../Components/BlockLeft';
import BlockRight from '../Components/BlockRight';

const Main = () => {
  return (
    <div>
      <Hero />
      <BlockRight data={block1Data} />
      <BlockLeft data={block2Data} />
    </div>
  );
};

export default Main;
